import { createFileRoute } from '@tanstack/react-router';
import { NotificationsScreen } from '@/notifications/NotificationsScreen';

export const Route = createFileRoute('/_app/notifications/read')({
  component: ReadNotificationsRoute,
});

function ReadNotificationsRoute() {
  return <NotificationsScreen isReadView />;
}

export default ReadNotificationsRoute;
